// extracted by mini-css-extract-plugin
export default {"profileRoot":"MyProfile_profileRoot__y2Pk2"};